import React from 'react';
import { Icon } from 'components/antd';
import { VehicleIconType } from 'components/antd/Icon/IconTypes';

interface Props {
	carTypeName: string;
}
const getVehicleIcon = (carTypeName: string): keyof VehicleIconType => {
	const vehiclesNames = ['Executive', 'MPV', 'Standard'];
	if (vehiclesNames.includes(carTypeName)) {
		return `${carTypeName.toLowerCase()}Gray` as keyof VehicleIconType;
	}
	return 'otherGray';
};
export const VehicleIcon: React.FC<Props> = ({ carTypeName }) => {
	return <Icon type={getVehicleIcon(carTypeName)} />;
};
